import React, { useState } from 'react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import type { ProductFaqsConfig } from '../../../product-subpage/types';

export const PlatformFaqs: React.FC<{ faqs: ProductFaqsConfig }> = ({ faqs }) => {
  const items = faqs.items ?? [];
  const [openIndex, setOpenIndex] = useState<number>(0);

  if (!items.length) return null;

  return (
    <SiteSection id="faqs" className="platform-faqs platform-faqs--premium">
      <SiteSectionHeader eyebrow={faqs.eyebrow ?? 'FAQs'} title={faqs.title} align="center" />
      <div className="platform-faqs__wrap">
        {items.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={item.question} className={`platform-faqs__item${isOpen ? ' is-open' : ''}`}>
              <button
                type="button"
                className="platform-faqs__q"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex((prev) => (prev === i ? -1 : i))}
              >
                <span className="platform-faqs__q-num">{i + 1}.</span>
                <span className="platform-faqs__q-text">{item.question}</span>
                <span className="platform-faqs__chev" aria-hidden />
              </button>
              <div className="platform-faqs__a" role="region" aria-hidden={!isOpen}>
                <div className="platform-faqs__a-inner">
                  <p>{item.answer}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </SiteSection>
  );
};
